module.exports = __webpack_public_path__ + "img/Rolld_Logo-1.119e2a67.png";